export const SET_DASHBOARD_ALREADY_IMMAPER_FORM = 'SET_DASHBOARD_ALREADY_IMMAPER_FORM';
export const SET_BULK_DASHBOARD_ALREADY_IMMAPER_FORM = 'SET_BULK_DASHBOARD_ALREADY_IMMAPER_FORM';
export const RESET_BULK_DASHBOARD_ALREADY_IMMAPER_FORM = 'RESET_BULK_DASHBOARD_ALREADY_IMMAPER_FORM';
